export default __webpack_public_path__ + "static/media/mail1.7cf64047.png";